import {AxiosResponse} from "axios";
import AxiosApiInstance, {APIBase} from "../AxiosApiInstance";

export const ApiRecommendationsDelete: (id: string) => Promise<AxiosResponse<void>> = (id) => {
  return AxiosApiInstance.delete(`${APIBase}recommendations/${id}/`);
};